<template>
  <div class="profile-layout sample-profile smpl-lyuot type-profile">
    <sample-navbar></sample-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links">
          <div v-popover.right="{ name: 'Company About The Data' }">
            <sidebar-item
              :link="{
                name: 'About',
                icon: 'help',
                path: `/sample/company-profile/company-about-the-data`,
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="profileInfo || !loading ? '' : 'disabled-item'"
            :link="{
              name: 'Company Details',
              icon: 'info',
              path: `/sample/company-profile/profile`,
            }"
          ></sidebar-item>

          <div v-popover.right="{ name: 'Finanical Insights' }">
            <sidebar-item
              :class="profileInfo || !loading ? '' : 'disabled-item'"
              :link="{
                name: 'Bizminer Insights',
                icon: 'developer_board',
                path: `/sample/company-profile/finanical-insights`,
              }"
            ></sidebar-item>
          </div>


          <div v-popover.right="{ name: 'Covid Impact' }">
            <sidebar-item
              :class="profileInfo || !loading ? '' : 'disabled-item'"
              :link="{
                name: 'Industry COVID-19',
                icon: 'local_hospital',
                path: `/sample/company-profile/covid-impact`,
              }"
            ></sidebar-item>
          </div>
        <!--
          <div v-popover.right="{ name: 'Company Contacts' }">
            <sidebar-item
                  :link="{
                  name: 'Company Contacts',
                  icon: 'help',
                  path: `/sample/company-profile/company-contacts`,
                  type: 'product',
                  }"
                  >
            </sidebar-item>
          </div>

          <div v-popover.right="{ name: 'Company Marketing' }">
            <sidebar-item
                  :link="{
                  name: 'Company Marketing',
                  icon: 'language',
                  path: `/sample/company-profile/web-presence`,
                  type: 'product',
                  }"
                  >
            </sidebar-item>


          </div>
          <div v-popover.right="{ name: 'Company Credit and Benefit' }">
            <sidebar-item
              :link="{
              name: 'Company Credit and Benefit',
              icon: 'credit_card',
              path: `/sample/company-profile/credit`,
              type: 'product',
              }"
              >
            </sidebar-item>


          </div>  -->
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <router-view :headerData="headerData" v-if="!loading || isAboutRoute" />
            <!--<PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>

import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';


function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith('Win');
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar('sidebar');
    initScrollbar('sidebar-wrapper');
    initScrollbar('main-panel');

    docClasses.add('perfect-scrollbar-on');
  } else {
    docClasses.add('perfect-scrollbar-off');
  }
}

function initSidebar() {
  document.body.classList.toggle('sidebar-mini');
}

import SampleNavbar from './SampleNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import MobileMenu from './Extra/MobileMenu.vue';
import { PulseLoader } from '@/components';
import Vuex from 'vuex';
import axios from 'axios';

export default {
  components: {
    SampleNavbar,
    ContentFooter,
    MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: 'grey',
      sidebarBackground: 'green',
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + '/img/sidebar-2.jpg',
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + '/img/laravel-vue.svg',
      roles: [],
      loading: true,
      isAboutRoute: false,
      headerData: [],
    };
  },
  methods: {
    async init() {
      this.loading = true;

      await this.$store.dispatch('sample/getCompanyProfile').then((res) => {
        this.$store.commit('SET_PROFILE_INFO', res.data);
        this.loading = false;
      });
    },
    checkRoute() {
      if (this.$route.name === 'SampleCompanyAboutTheData')
        return true;

      return false;
    },
  },
  mounted() {
    this.isAboutRoute = this.checkRoute();
    this.init();
  },
  async created() {

  },

  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
    id() {
      return this.$route.params.id;
    },
    profileInfo() {
      return this.$store.getters.profileInfo;
    },
    profileInfoId() {
      return this.$store.getters.profileInfoId;
    },
  },
  watch: {
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.disabled-item {
  opacity: 0.5;
  pointer-events: none;
}
</style>
